export function PageWrapper({ children, className = "" }) {
  return (
    <div className={`px-5 py-10 md:p-10 w-full min-h-screen ${className}`}>
      {children}
    </div>
  );
}
